<template>
  <div id="app">
    <v-app id="avtouragan">
        <SideMenu :menu_width="side_menu_width" v-if="$store.state.user.logged_in === true"></SideMenu>
        <v-main :class="{ 'main-wrapper': $router.currentRoute.name !== 'Login' }">
            <router-view :class="{ 'router-pages': $router.currentRoute.name !== 'Login' }"
                         style="height: calc(100% - 20px); margin-top: 20px">

            </router-view>
        </v-main>
        <!--
        <router-view></router-view>
        -->
      <Snackbar></Snackbar>
      <loading-overlay v-if="loadingOverlay.is_loading"/>
    </v-app>
  </div>
</template>

<script>
// import router from "@/router";
import {mapActions, mapGetters,} from "vuex";
import {EventBus} from "@/bus";
import SideMenu from "@/pages/SideMenu";
import {Trans} from "@/plugins/transition";

// import '@/assets/styles/global.scss'
import '@/styles/global.scss'
import LoadingOverlay from "@/components/LoadingOverlay";
import {i18n} from "@/i18n";
import {common_funcs} from "@/mixins/common";
import {initialize_ws_connection} from "./utils/websocket_connection";

// import moment from 'moment'
// import 'moment-timezone'

export default {
  name: 'App',
  components: {
    LoadingOverlay,
    SideMenu
  },
  mixins: [common_funcs],
  data: function () {
    initialize_ws_connection()
    EventBus.$on('ws_on_message', this.ws_on_message)
    this.get_timezones()
    // this.get_system_settings()
    console.log(Trans.currentLocale)
    return {
      side_menu_width: '20vw',
    }
  },
  methods: {
    ws_on_message: function (message) {
          message = JSON.parse(message)
          let method = message.method
          let params = message.params
          switch (method) {
            case 'handshake':
              this.handshake(params)
                  break
            case 'send_system_datetime':
              this.show_system_datetime(params)
                  break
            case 'send_relay_connection_state':
              this.set_relays_connection_state(params)
                  break
            case 'send_service_connection_state':
              this.set_service_connection_state(params)
                  break
            case 'start_loading_overlay':
              this.set_loading_overlay(params)
                  break
            case 'send_ws_error_message':
              this.process_ws_error_message(params)
                  break
          }
      },
    handshake: function (params) {
      this.$store.state.current_system_timezone = params.current_system_timezone
      this.updateLoadingOverlay({is_loading: false, reload_required: false})
      this.$store.state.loading_overlay.reload_required = false
      this.get_system_settings()
    },
    get_timezones: function () {
      let t = this
      this.$store.state.current_browser_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      this.$http({url: this.$http_hostname + '/system_settings/get_datetime_info', method: 'GET'})
      .then(resp => {
        t.$store.state.current_system_timezone = resp.data.current_timezone
      })
      .catch(() => {
        this.setSnackbar({
          text: i18n.t('notifications.system.couldnt_get_timezone'),
        })
      })
    },
    get_system_settings: function () {
      this.$http({url: this.$http_hostname + '/system_settings/get_config_params', method: 'GET'})
      .then(resp => {
        this.updateSystemParams({
          journal_data_storage_period: resp.data.journal_data_storage_period,
          service_connection_url: resp.data.service_connection_url,
          library_license_key: resp.data.library_license_key,
          serial: resp.data.serial,
          name: resp.data.name,
          network_role: resp.data.network_role,
          network_connection_url: resp.data.network_connection_url,

          processing_method: resp.data.processing_method,
          passage_detection_method: resp.data.passage_detection_method,
          re_recognition_delay: resp.data.re_recognition_delay,
          min_plate_width: resp.data.min_plate_width,
          max_plate_width: resp.data.max_plate_width,

          memory_check_schedule: resp.data.memory_check_schedule,
          memory_check_schedule_weekdays: resp.data.memory_check_schedule_weekdays,
          memory_check_schedule_daily_start_time: resp.data.memory_check_schedule_daily_start_time,
          memory_check_schedule_daily_end_time: resp.data.memory_check_schedule_daily_end_time
        })
      })
      .catch(error => {
        this.show_error_message(error)
      })
    },
    show_system_datetime: function (params) {
        let system_datetime_obj = new Date(params.system_datetime['$date'])
        this.updateDatetime({datetime: system_datetime_obj})
    },
    set_relays_connection_state: function (params) {
      this.updateRelayConnectionState({
        relays_are_connected: params.relays_are_connected
      })
    },
    set_service_connection_state: function (params) {
      this.updateServiceConnectionState(
          {
            service_is_connected: params.service_is_connected,
          }
      )
    },
    set_loading_overlay: function (params) {
      let loading_overlay_params = params
      loading_overlay_params['is_loading'] = true
      loading_overlay_params['reload_required'] = false
      this.updateLoadingOverlay(loading_overlay_params)
    },
    process_ws_error_message: function (params) {
      if (params.section === 'devices_network') {
        let values = {}
        switch (params.message) {
          case 'broadcast_error':
            values = {'devices_serials': params.details.devices_serials}
            break
          case 'single_device_error':
            values = {'device_serial': params.details.device_serial}
            break
          default:
            break
        }
        this.setSnackbar({
          text: i18n.t(`notifications.${params.section}.${params.message}`, values),
          timeout: 5000,
        })
      }
    },
    ...mapActions([
          'changeUserData',
          'updateDatetime',
          'isUserLoggedIn',
          'updateLoadingOverlay',
          'updateRelayConnectionState',
          'updateServiceConnectionState',
          "updateSystemParams"
        ])
    },
  computed: {
    ...mapGetters(['loadingOverlay'])
  },
};
</script>

<style lang="scss">
.router-pages {
  margin-top: 30px;
  margin-right: 70px;
  margin-left: 20px;
}
#main-container {
  display: flex;
}
#avtouragan {
  background-color: #F2F2F2;
  // background-color: #99cc66;
}
/* Changes all datatable headers */
.v-data-table > .v-data-table__wrapper > table > thead > tr > th{
   font-size: 15px !important;
   opacity: 0.7 !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
   font-size: 15px !important;
   font-family: Roboto,serif;
   letter-spacing: 0.25px !important;
   color: #303030 !important;
    vertical-align: middle;
}

.v-application {
    font-family: Roboto,serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px !important;
    /* line-height: 20px !important; */

    /* identical to box height, or 143% */
    display: flex;
    align-items: center;
    letter-spacing: 0.25px !important;

    /* primary/black */
    color: #303030 !important;
 }

.main-wrapper {
  padding: 0 0 0 20% !important;
}
</style>



